import { useEffect, useState } from "react";
import { Box, Container, Stack } from "@chakra-ui/react";
import { YouTubeEmbed } from "./YouTubeEmbed";
import { useCmsApi } from "../../services/useCmsApi";

const DEFAULT_VIDEO_ID = "ZA4NQV8vVng";

export const VideoSection = (): JSX.Element => {
	const [videoId, setVideoId] = useState(DEFAULT_VIDEO_ID);
	const cmsApi = useCmsApi();

	useEffect(() => {
		cmsApi.getSiteSetting("mainVideoId").then((setting) => {
			if (setting?.value) setVideoId(setting.value);
		});
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<Box bg="gray.50" py={{ base: "16", md: "20" }}>
			<Container maxW="1120px">
				<Stack spacing="10" align="center">
					<YouTubeEmbed
						src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&mute=1&rel=0&loop=1&playlist=${videoId}`}
						center
						borderRadius="2xl"
						boxShadow="xl"
						maxW="960px"
						w="full"
					/>
				</Stack>
			</Container>
		</Box>
	);
};
